import script from "./ImageBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageBlock.vue?vue&type=script&setup=true&lang=ts"

import "./ImageBlock.vue?vue&type=style&index=0&id=e24ebcb0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e24ebcb0"]])

export default __exports__